import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const PaymentResultPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'failed'>('loading');

  const orderId = searchParams.get('orderId');
  // ClickPay appends respStatus to the return URL
  const respStatus = searchParams.get('respStatus') || searchParams.get('payment_result.response_status');

  useEffect(() => {
    if (respStatus === 'A') {
      setStatus('success');
    } else if (respStatus === 'D' || respStatus === 'E') {
      setStatus('failed');
    } else {
      // No status param yet — wait a moment then check
      const timer = setTimeout(() => setStatus('failed'), 5000);
      return () => clearTimeout(timer);
    }
  }, [respStatus]);

  return (
    <div className="min-h-screen bg-[#FCFCFC] flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl shadow-lg p-10 max-w-md w-full text-center">
        {status === 'loading' && (
          <>
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#DAA520] mx-auto mb-4" />
            <p className="text-gray-600">Verifying your payment...</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="text-5xl mb-4">✅</div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2">Payment Successful!</h2>
            <p className="text-gray-500 mb-6">Your order has been confirmed. You'll receive a confirmation shortly.</p>
            <button
              onClick={() => navigate('/orders')}
              className="bg-[#DAA520] text-white px-8 py-3 rounded-lg font-semibold hover:bg-[#c5941c] w-full"
            >
              View My Orders
            </button>
          </>
        )}

        {status === 'failed' && (
          <>
            <div className="text-5xl mb-4">❌</div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2">Payment Failed</h2>
            <p className="text-gray-500 mb-6">Your payment could not be processed. Your order is saved — you can retry or pay on delivery.</p>
            <div className="space-y-3">
              {orderId && (
                <button
                  onClick={() => navigate('/checkout')}
                  className="bg-[#E91E63] text-white px-8 py-3 rounded-lg font-semibold hover:bg-[#D81B60] w-full"
                >
                  Try Again
                </button>
              )}
              <button
                onClick={() => navigate('/orders')}
                className="border border-[#DAA520] text-[#DAA520] px-8 py-3 rounded-lg font-semibold hover:bg-[#DAA520]/10 w-full"
              >
                View My Orders
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentResultPage;
